import * as React from "react";
import Button from '@material-ui/core/Button';

export class NewCoachButton extends React.Component {

  constructor(public props) {
    super(props);
  }

  public render() {
    const { activeStep, steps, onPageChange, onCloseCoach, trans, showBackButton, disabledBack, disabledNext, onNext } = this.props;
    return (
      <div className={`button-container step-footer ${activeStep === steps.length - 1 ? "without-cancel" : ""}`}>
        <div style={{paddingRight: "7px"}}>
        { activeStep !== 0 && activeStep !== steps.length - 1 && showBackButton && 
          <Button
            color="primary"
            variant="outlined"
            onClick={() => onPageChange.apply(this, [activeStep - 1, false])}
            className="back-button"
            disabled={disabledBack}
          >
            {trans("dialog-button/back")}
          </Button>
          }

          <Button
            variant="contained"
            color="primary"
            disabled={disabledNext}
            onClick={onNext ? onNext : () => {
              activeStep === steps.length - 1 ? onCloseCoach.call(this, true) : onPageChange.apply(this, [activeStep + 1, true])
            }}
          >
            {activeStep === steps.length - 1 ? trans("button-close") : !this.props.forelastNextButton && activeStep === steps.length - 2 ? trans("button-finish") : trans("button-next")}
          </Button>
        </div>
      </div>
    );
  }
}
